import { BodyText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { AT } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import PlaybackAction from "src/pods/ideas/components/video/PlaybackAction";
import PlaybackControls from "src/pods/ideas/components/video/PlaybackControls";
import { Lesson, Slide } from "src/pods/ideas/data/types";

type WatchVideoProps = {
  watch: Slide;
  lesson: Lesson;
  isPlaying?: boolean;
  isFullscreen?: boolean;
  onPlayOnPhone: VoidFunction;
  onToggleFullscreen: VoidFunction;
  onTogglePlay: VoidFunction;
  onForward: (time: number) => void;
  onReplay: (time: number) => void;
};

export default function WatchVideo({
  watch,
  lesson,
  isPlaying,
  isFullscreen,
  onPlayOnPhone,
  onToggleFullscreen,
  onTogglePlay,
  onForward,
  onReplay,
}: WatchVideoProps) {
  return (
    <article sx={pageStyle}>
      <section sx={cardStyle}>
        <div sx={lessonCardWatchScreenPosterStyle}>
          {false && (
            <div>
              <img sx={lessonCardWatchScreenPosterImgStyle} src={watch.poster_url} alt={lesson.title} />
            </div>
          )}
          <PlaybackControls innerSx={playbackControlsStyle}>
            <PlaybackAction icon="replay_10" innerSx={outlinePlaybackActionStyle} onClick={() => onReplay(10)} />
            <PlaybackAction
              icon={isPlaying ? "pause" : "play_arrow"}
              innerSx={mainPlaybackActionStyle}
              onClick={onTogglePlay}
            />
            <PlaybackAction icon="forward_10" innerSx={outlinePlaybackActionStyle} onClick={() => onForward(10)} />
            {false && (
              <PlaybackAction
                icon={isFullscreen ? "fullscreen_exit" : "fullscreen"}
                innerSx={outlinePlaybackActionStyle}
                onClick={() => onToggleFullscreen()}
              />
            )}
          </PlaybackControls>
          <div sx={stateStyle}>
            <BodyText>Video is playing on your computer</BodyText>
            <a
              data-name="watch_video:mojo_show_video_play_on_phone"
              href="#"
              sx={playOnPhoneInstead}
              onClick={(e) => {
                e.preventDefault();
                onPlayOnPhone();
              }}
            >
              <AT>Play on phone instead</AT>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
}

const pageStyle: ThemeUIStyleObject = {
  fontSize: "28px",
};

const cardStyle: ThemeUIStyleObject = {
  maxWidth: "864px",
  margin: "auto",
  textAlign: "center",
};

const stateStyle: ThemeUIStyleObject = {
  marginBottom: RAW_cssValue(20),
  marginTop: RAW_cssValue(20),
};

const playOnPhoneInstead: ThemeUIStyleObject = {
  color: "dt_content_plus",
  fontWeight: 600,
  fontSize: 20,
};

const outlinePlaybackActionStyle: ThemeUIStyleObject = {
  color: "dt_content_tertiary",
  border: RAW_cssValue("solid 1px rgba(0, 0, 0, 0.12)"),
  fontSize: 32,
};

const mainPlaybackActionStyle: ThemeUIStyleObject = {
  backgroundColor: "dt_content_danger",
  color: "dt_content_light",
};

const playbackControlsStyle: ThemeUIStyleObject = {
  marginTop: RAW_cssValue(60),
  marginBottom: RAW_cssValue(60),
};

const lessonCardWatchScreenPosterStyle: ThemeUIStyleObject = {
  width: "50%",
  margin: RAW_cssValue("0px auto"),
};

const lessonCardWatchScreenPosterImgStyle: ThemeUIStyleObject = {
  height: "120px",
  borderRadius: "dt_radius_s",
  objectFit: "contain",
  filter: "blur(2px)",
};
